<template>
  <div>
    <PageHeader :title="update ? 'ویرایش اسلایدر' : 'اضافه کردن اسلایدر'" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <div class="card">
      <Section title="بنر نسخه دسکتاپ ">
        <ImageUploader
          :img="model.largeImage"
          :uploadLoading="largeImageLoading"
          :secondTitle="`سایز 710 × 1920 `"
          title="عکس بنر را انتخاب کنید"
          @uploadImage="uploadLargeImage"
          @deleteImage="model.largeImage = ''"
        />
        <div class="my-3">
          <BaseText v-model="model.largeImageText" title="متن جایگزین " placeholder="متن جایگزین " labelClass="labelClass" />
        </div>
      </Section>
      <Section title="بنر نسخه تبلت و گوشی ">
        <ImageUploader
          :img="model.smallImage"
          :uploadLoading="smallImageLoading"
          :secondTitle="`سایز 300 × 430 `"
          title="عکس بنر را انتخاب کنید"
          @uploadImage="uploadSmallImage"
          @deleteImage="model.smallImage = ''"
        />
        <div class="my-3">
          <BaseText v-model="model.smallImageText" title="متن جایگزین " placeholder="متن جایگزین " labelClass="labelClass" />
        </div>
      </Section>
      <Section>
        <div class="my-3">
          <BaseText v-model="model.order" title="ترتیب بنر " placeholder="ترتیب بنر " labelClass="labelClass" />
        </div>
        <div class="my-3">
          <BaseText v-model="model.link" title="لینک شود به " placeholder="لینک شود به " labelClass="labelClass" />
        </div>
      </Section>
      <Toast :title="message" :error="error" :showToast="showToast" />

      <div class="card p-3 d-flex flex-row justify-content-end">
        <b-button @click="$router.go(-1)">انصراف</b-button>
        <b-button variant="primary ms-2 px-5" @click="onSubmit">ثبت</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import fileMannager from '../../../services/file'
import skillUpBannerProvider from '../../../services/skillUp/banner'
import Toast from '../../common/Toast.vue'
import Section from '../../common/form/Section.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import PageHeader from '../../layoutComponents/page-header.vue'
import ImageUploader from '../../user/ImageUploader.vue'
import Loader from '../../widgets/loader.vue'

export default {
  name: 'AddSlider',
  components: { PageHeader, Loader, Section, ImageUploader, BaseText, Toast },
  props: {
    update: {
      type: Boolean,
    },
  },
  data() {
    return {
      model: {
        title: '',
        description: '',
        largeImage: '',
        largeImageText: '',
        smallImage: '',
        smallImageText: '',
        firstColor: '',
        secondColor: '',
        thirdColor: '',
        link: '',
        order: '',
        show: true,
      },
      smallImageLoading: false,
      largeImageLoading: false,
      message: '',
      showToast: false,
      submit: false,
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت اسلایدر', active: true },
      ],
    }
  },
  mounted() {
    if (this.update) {
      this.fetchBanner()
    }
  },
  methods: {
    async onSubmit() {
      this.showToast = false
      this.loading = true
      try {
        if (this.update) {
          await skillUpBannerProvider.updateBanner({ ...this.model, order: +this.model.order })
        } else {
          const req = await skillUpBannerProvider.AddFirstSlider({ ...this.model, order: +this.model.order })
          if (req.status === 200) this.$router.push('/list/homeslider/detail/' + req.data.data.id)
        }
        this.message = 'اطلاعات با موفقیت ثبت شد.'
        this.showToast = true
        this.loading = false
      } catch (error) {
        this.message = 'خطایی رخ داده، لطفا مجددا تلاش کنید.'
        this.showToast = false
        this.loading = false
      }
    },
    async uploadLargeImage(e) {
      this.largeImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.largeImageLoading = false
      this.model.largeImage = req.data.data.downloadUrl
    },
    async uploadSmallImage(e) {
      this.smallImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.smallImageLoading = false
      this.model.smallImage = req.data.data.downloadUrl
    },
    async fetchBanner() {
      const req = await skillUpBannerProvider.getBanner(this.$route.params.detail)
      this.model = req.data.data.output
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .labelClass {
  min-width: 100px !important;
}
</style>
